import ApprovePaymentPlanError from './ApprovePaymentPlanError';
class InsufficientBricks extends ApprovePaymentPlanError {
    constructor(options) {
        super('The resource bricks is insufficient', options);
    }
}
export default InsufficientBricks;
